import { installInsertTools } from '@openleaf-editor/plugins-insert'

installInsertTools()
